export default __webpack_public_path__ + "static/media/policy-16px.5388c910.svg";